var u = Object.defineProperty;
var c = (s, t, e) => t in s ? u(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var i = (s, t, e) => (c(s, typeof t != "symbol" ? t + "" : t, e), e);
class o {
  constructor(t) {
    i(this, "xhr");
    this.xhr = t;
  }
  get status() {
    return this.xhr.status;
  }
  get message() {
    return this.xhr.statusText;
  }
  get data() {
    return this.xhr.response;
  }
  get redirect() {
    return this.data.redirect;
  }
  get errors() {
    return this.data.errors;
  }
  get visitor() {
    return this.success && !!this.xhr.getResponseHeader("x-visitor");
  }
  get partial() {
    return this.visitor && this.success && !!this.xhr.getResponseHeader("x-partial");
  }
  get success() {
    return this.status >= 200 && this.status < 300;
  }
  get failed() {
    return this.status >= 400 && this.status < 600;
  }
}
class d {
  constructor(t, e, r = null) {
    i(this, "method");
    i(this, "url");
    i(this, "xhr");
    i(this, "body");
    this.xhr = new XMLHttpRequest(), this.method = t, this.url = e, this.body = r;
  }
  abort() {
    this.xhr.abort();
  }
  send() {
    return new Promise((t, e) => {
      this.xhr.responseType = "json", this.xhr.open(this.method, this.url, !0), this.xhr.setRequestHeader("Accept", "application/json"), this.xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest"), this.xhr.setRequestHeader("X-Visitor", "true"), this.xhr.setRequestHeader("X-XSRF-TOKEN", this.readCookie("XSRF-TOKEN")), this.xhr.onload = () => {
        if (this.xhr.readyState !== XMLHttpRequest.DONE || !this.xhr.status)
          return;
        const r = new o(this.xhr);
        r.failed && e(r), t(r);
      }, this.xhr.onerror = () => {
        e(new o(this.xhr));
      }, this.xhr.send(
        this.transform(this.body)
      );
    });
  }
  transform(t) {
    return t instanceof Blob || t instanceof ArrayBuffer || t instanceof FormData || t instanceof URLSearchParams || typeof t == "string" ? t : t === null ? null : (this.xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), JSON.stringify(t));
  }
  readCookie(t) {
    const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
    return e ? decodeURIComponent(e[3]) : "";
  }
}
class l {
  constructor() {
    i(this, "finder");
    i(this, "onUpdate");
    i(this, "location");
    i(this, "state");
    i(this, "request");
  }
  init({ state: t, finder: e, update: r }) {
    this.finder = e, this.onUpdate = r, this.initializeFirstVisit(t), this.initializeStateEvents();
  }
  initializeStateEvents() {
    window.addEventListener("popstate", this.handlePopstateEvent.bind(this));
  }
  initializeFirstVisit(t) {
    this.replaceHistoryState(t);
  }
  fireEvent(t, e = {}) {
    return document.dispatchEvent(new CustomEvent(`visitor:${t}`, e));
  }
  dispatch({ method: t, url: e, body: r = null, replace: h = !1 }) {
    return this.request !== void 0 && this.request.abort(), this.fireEvent("start"), this.request = new d(t, e, r), this.request.send().then((a) => a.partial ? this.handlePartialResponse(a) : a.visitor ? this.updateComponent(this.mergeState(a.data), h) : a).catch((a) => this.fireEvent("error") && Promise.reject(a)).finally(() => {
      this.fireEvent("done");
    });
  }
  handlePartialResponse(t) {
    return this.mergeState(t.data, !0), t.redirect ? t.redirect.reload ? new Promise(() => {
      window.location.href = t.redirect.target;
    }) : this.dispatch({
      method: "GET",
      url: t.redirect.target,
      replace: !1
    }) : this.updateComponent(this.state, !0);
  }
  mergeState(t, e = !1) {
    return this.state = {
      view: e ? this.state.view : t.view,
      query: t.query,
      session: t.session,
      location: t.location,
      // We always merge shared state, as it's kept between requests.
      shared: { ...this.state.shared, ...t.shared },
      // Merge components props only for partial updates.
      // When we have full update, replace props with fresh ones.
      props: e ? { ...this.state.props, ...t.props } : t.props,
      version: t.version
    }, this.state;
  }
  refresh() {
    return this.dispatch({
      method: "GET",
      url: this.location,
      replace: !0
    });
  }
  pushHistoryState(t) {
    return this.state = t, window.history.pushState(t, "", t.location), t;
  }
  replaceHistoryState(t) {
    return this.state = t, window.history.replaceState(t, "", t.location), t;
  }
  handlePopstateEvent(t) {
    t.state !== null ? this.updateComponent(t.state) : this.replaceHistoryState(this.state);
  }
  updateComponent(t, e = !1) {
    return this.finder(t.view).then((r) => (this.resetScrollPosition(), this.updateHead(t.props.meta), e ? this.replaceHistoryState(t) : this.pushHistoryState(t), this.onUpdate.call(this, { component: r, ...t }), t));
  }
  resetScrollPosition() {
    window.scrollTo(0, 0);
  }
  updateHead(t) {
    t && (document.head.querySelectorAll("[visitor]").forEach((e) => e.remove()), t.forEach((e) => {
      let r;
      switch (e.type) {
        case "title":
          r = document.createElement("title"), r.innerHTML = e.content;
          break;
        case "meta":
          r = document.createElement("meta"), r.setAttribute("name", e.name), r.setAttribute("content", e.content);
          break;
        case "snippet":
          r = document.createElement("script"), r.setAttribute("type", "application/ld+json"), r.innerHTML = e.content;
          break;
      }
      r.setAttribute("visitor", ""), document.head.append(r);
    }));
  }
}
const n = new l(), m = {
  is_authenticated: !1,
  user: null,
  via_remember: !1,
  flash: {}
}, f = (s) => n.dispatch({ method: "GET", url: s }), x = (s, t) => n.dispatch({ method: "POST", url: s, body: t }), v = (s, t) => n.dispatch({ method: "PATCH", url: s, body: t }), E = (s, t) => n.dispatch({ method: "PUT", url: s, body: t }), w = (s) => n.dispatch({ method: "DELETE", url: s }), S = () => {
  n.refresh();
}, H = (s) => {
  n.dispatch({ method: "GET", url: s });
}, R = (s) => {
  n.init(s);
};
export {
  w as $delete,
  f as $get,
  R as $init,
  v as $patch,
  x as $post,
  E as $put,
  H as $redirect,
  S as $refresh,
  m as defaultSession
};
